import type { Reducer } from "@reduxjs/toolkit";

type MockAppState = {
    activeBranch: string;
    banner: { content: string } | null;
    loading: boolean;
    menuIsExpanded: boolean;
    menuItems: any[];
    breadcrumbStack: any[];
    errors: Record<string, any>;
    user: Record<string, any>;
    settings: Record<string, any>;
};

// A recognizable branch value lets tests assert that store-derived bindings actually flow from the store...
const initialState: MockAppState = {
    activeBranch: "stub-branch",
    banner: null,
    loading: false,
    menuIsExpanded: true,
    menuItems: [],
    breadcrumbStack: [],
    errors: {},
    user: {},
    settings: {},
};

export const appReducer: Reducer<MockAppState, any, MockAppState> = (state = initialState) => state;
